module.exports = __webpack_public_path__ + "static/img/beihuo.0e1bd90c.png";